module.exports = __webpack_public_path__ + "static/home-793b6941d830dbffaee0b5367fb41e91.jpg";